import { render, staticRenderFns } from "./FieldPermissions.vue?vue&type=template&id=6fc6ee8b&scoped=true&"
import script from "./FieldPermissions.vue?vue&type=script&lang=js&"
export * from "./FieldPermissions.vue?vue&type=script&lang=js&"
import style0 from "./FieldPermissions.vue?vue&type=style&index=0&id=6fc6ee8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6ee8b",
  null
  
)

/* custom blocks */
import block0 from "./FieldPermissions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports